module.exports = __webpack_public_path__ + "img/Shaman-orc-f-60.3905e8ac.gif";